// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { LinesHeader } from "@keller/App/Components/Cart/CartContainerLayout";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CartLinesListHeaderStyles {
    wrapper?: InjectableCss;
    productCountText?: TypographyPresentationProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    condensedCheckbox?: CheckboxPresentationProps;
}

export const cartLinesListHeaderStyles: CartLinesListHeaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 10px;
        `,
    },
    productCountText: {
        variant: "h4",
    },
    checkboxGroup: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
};

const CartLinesListHeader: FC<{
    productsCount: number;
    isCondensed: boolean;
    hideCondensedSelector?: boolean;
    onChangeIsCondensed?: (event: React.SyntheticEvent, value: boolean) => void;
    extendedStyles?: CartLinesListHeaderStyles;
}> = ({ productsCount, onChangeIsCondensed, extendedStyles, isCondensed, hideCondensedSelector }) => {
    const [styles] = React.useState(() => mergeToNew(cartLinesListHeaderStyles, extendedStyles));
    // Xng-Changes: not needed
    // const productsLabel = productsCount > 1 ? "" : "Product";

    return (
        <>
            {/* XNG-Changes: remove products count */}
            <Typography {...styles.productCountText} as="h3">
                {translate("Products")}
            </Typography>
            {/* <XNG-Changes> use LinesHeader */}
            <LinesHeader />
            {/* </XNG-Changes> */}
            {/* XNG-Changes: move title up and remove because its not needed as the design */}
            {/* <StyledWrapper {...styles.wrapper}>
                {!hideCondensedSelector && (
                    <CheckboxGroup {...styles.checkboxGroup}>
                        <Checkbox {...styles.condensedCheckbox} checked={isCondensed} onChange={onChangeIsCondensed}>
                            {translate("Condensed View")}
                            <VisuallyHidden>{translate("for product list")}</VisuallyHidden>
                        </Checkbox>
                    </CheckboxGroup>
                )}
            </StyledWrapper> */}
        </>
    );
};

export default CartLinesListHeader;
